/**
* Created by lobin on 2020/8/11.
*/
<template>
	<div class="recharge">
		<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
			<a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
				<a-form-model-item>
					<company-search
						v-model="search.company"
						placeholder="请选择所属公司"
					/>
				</a-form-model-item>
				<a-form-model-item>
					<station-select type="input" v-model="search.station" />
				</a-form-model-item>
				<a-form-model-item>
					<a-input v-model="search.mailNo" placeholder="输入快递单号" allowClear></a-input>
				</a-form-model-item>
				<a-form-model-item>
					<a-range-picker
						v-model="timeRange"
						format="YYYY-MM-DD"
						valueFormat="YYYY-MM-DD"
					/>
				</a-form-model-item>
				<a-form-model-item>
					<a-button
						type="primary"
						html-type="submit"
						icon="search"
					>
						查询
					</a-button>
				</a-form-model-item>
			</a-form-model>
			<a-divider />
			<a-table
				:loading="loading"
				:columns="columns"
				:data-source="list"
				:scroll="{y: $store.getters.listTableHeight }"
				:pagination="pager"
				rowKey="_id"
				@change="change">
				<span slot="isPay" slot-scope="text, record">
					<a-tag color="green" v-if="record.isPay">成功</a-tag>
					<a-tag color="red" v-else>失败</a-tag>
				</span>
				<span slot="refund" slot-scope="text, record">
					<a-tag color="green" v-if="record.refund">成功</a-tag>
					<a-tag color="red" v-else>失败</a-tag>
        		</span>
				<span slot="user" slot-scope="text, record">
          <a-avatar :src="record.user.headimgurl" />
          <span style="margin-left: 10px">{{ record.user.nickname }}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button @click="refund(record._id)" type="link" :disabled="record.refund">
            退款
          </a-button>
        </span>
			</a-table>
		</a-card>
	</div>
</template>

<script type="text/babel">
import { overTimePay, refund } from '@/api/financial';

export default {
  data() {
    return {
      search: {
      },
      list: [],
      pager: {},
	    timeRange: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
        {
				  title: '#',
				  dataIndex: 'index',
				  customRender: (text, row, index) => index + 1,
				  key: 'index',
				  width: '50px',
			  },
			  {
				  title: '公司名称',
		      ellipsis: true,
				  dataIndex: 'company.name',
				  key: 'name',
			  },
	      {
		      title: '站点',
		      dataIndex: 'station.name',
	        ellipsis: true,
		      key: 'stationName',
	      },
	      {
		      title: '用户',
		      dataIndex: 'user',
		      key: 'user',
	        scopedSlots: { customRender: 'user' },
	      },
	      {
		      title: '金额',
		      dataIndex: 'fee',
		      key: 'fee',
	      },
	      {
		      title: '快递单号',
		      dataIndex: 'mailNo',
			    width: 160,
		      key: 'mailNo',
	      },
	      {
		      title: '支付订单号',
		      dataIndex: 'orderNo',
	        width: 160,
		      key: 'orderNo',
	        ellipsis: true,
	      },
	      {
		      title: '结果',
		      dataIndex: 'isPay',
		      key: 'isPay',
	        scopedSlots: { customRender: 'isPay' },
	      },
		  {
		      title: '退款结果',
		      dataIndex: 'refund',
		      key: 'refund',
	          scopedSlots: { customRender: 'refund' },
	      },
	      {
		      title: '时间',
		      dataIndex: 'ctime',
		      key: 'ctime',
	      },
		  {
		      title: '操作',
		      dataIndex: 'action',
		      key: 'action',
	        scopedSlots: { customRender: 'action' },
	      },
		  ];
	  },
  },
  methods: {
  	async getList() {
  		this.loading = true;
  		const q = { ...this.search };
  		if (this.timeRange) {
  			q.start = this.timeRange[0];
  			q.end = this.timeRange[1];
		  }
  		const { data: { docs, pager } } = await overTimePay(q);
  		this.list = docs;
  		this.pager = {
  			...pager,
		    showTotal: (total) => `共计 ${total} 条信息`,
  		};
	    this.loading = false;
	  },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    async refund(id) {
      await refund(id, '设备故障');
      this.$message.success('退款成功');
      this.getList();
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.recharge {

	}
</style>
